import { Component, OnInit, HostListener } from '@angular/core';
import { MyserviceService } from '../../provider/myservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import * as moment from 'moment';
import * as bath from 'thai-baht-text';
import { DomSanitizer } from '@angular/platform-browser';
@Component({
  selector: 'app-print-inform-3x4',
  templateUrl: './print-inform-3x4.component.html',
  styleUrls: ['./print-inform-3x4.component.scss']
})
export class PrintInformComponent_3X4 implements OnInit {
  @HostListener('window:afterprint', ['$event'])
  public afterPrintHandler(event) {
    window.close();
    window.stop();
    console.log('Printing finished or canceled.ๅๅๅ');
  }
  detail = [];
  invoice_id = '';
  customer_id = '';
  customer_name = '';
  place_description = '';
  place_address = '';
  place_id = '';
  fee_id = '';
  fee_description = '';
  due_datetime = '';
  create_datetime = '';
  price = '';
  total_price = '';
  discount = '';
  user = '';
  barcode = '';
  total_price_bath = '';
  background = '#ffffff'
  fee_count = '';
  isLoading = true;

  // New
  length = 0;
  now = '';
  tambon = '';
  amphur = '';
  province = '';
  postcode = '';
  fee_type_description = '';
  fee_type_unit = '';
  total = []
  total_baht = null;
  base64_img_muni = null;
  img_src = null;
  fee_type_price = '';
  barcode_cus_place = null;
  barcode_bill = null;
  place_owner = null;
  datenew = null;
  qr_code = null;
  municipality = null;
  base64_img_muni_qr = null;
  lineqr_code = null;
  base64_img_muni_lineqr = null;
  status_pay = null;
  date_filter = null;
  day = null;
  month = null;
  year = null;
  report = null;
  users = null;
  constructor(private route: ActivatedRoute, router: Router, private service: MyserviceService, private sanitizer: DomSanitizer) { };

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.invoice_id = params['invoice_id'];
      this.place_id = params['place_id'];
      this.status_pay = params['status_pay']
      this.date_filter = params['date_filter'];
      this.day = params['day'];
      this.month = params['month'];
      this.year = params['year'];
      this.report = params['report'];
    });

    this.refresh();
    const get_Storage_invoice_multi = sessionStorage.getItem('municipality')
    this.municipality = JSON.parse(get_Storage_invoice_multi)
    this.users = JSON.parse(sessionStorage.getItem('user'));

    this.base64_img_muni = `data:image/png;base64,${JSON.parse(get_Storage_invoice_multi).icon_img}`
    this.base64_img_muni_qr = `http://203.150.210.93:5002/${JSON.parse(get_Storage_invoice_multi).qr_code}`
    this.qr_code = this.sanitizer.bypassSecurityTrustUrl(this.base64_img_muni_qr);
    this.img_src = this.sanitizer.bypassSecurityTrustUrl(this.base64_img_muni);
    this.base64_img_muni_lineqr = `http://203.150.210.93:5002/${JSON.parse(get_Storage_invoice_multi).line_qr_code}`
    this.lineqr_code = this.sanitizer.bypassSecurityTrustUrl(this.base64_img_muni_lineqr);

  }

  refresh() {
    var formatter = new Intl.NumberFormat('th-TH', {
      style: 'currency',
      currency: 'THB',
    });
    var data;
    if (this.invoice_id != undefined) {
      data = { invoice_id: this.invoice_id, status_pay: this.status_pay, date_filter: JSON.parse(this.date_filter), report: this.report, day: this.day, month: this.month, year: this.year }
    }
    if (this.place_id != undefined) {
      data = { place_id: this.place_id, topic: 'inform', status_pay: this.status_pay, date_filter: JSON.parse(this.date_filter), report: this.report, day: this.day, month: this.month, year: this.year }
    }

    this.isLoading = true;
    this.service.postData(data, "invoice/get-invoice-detail").then((result: any) => {
      this.isLoading = false;
      console.log(result.data);
      if (!result.code) {
        if (result.data.length > 0) {

          this.length = Number(result.data.length);

          this.total = []

          this.detail = result.data.map(data => {

            const datenew = moment(new Date()).add(543, 'year').format("DD/MM/YYYY HH:mm:ss")
            const customer_id = data.customer_id;
            const customer_name = data.customer_name;
            const place_id = data.place_id;
            const place_address = data.place_address;
            const tambon = data.tambon_th;
            const amphur = data.amphur_th;
            const province = data.province_th;
            const postcode = data.postcode;
            const place_description = data.place_description;
            const mobile = data.mobile;
            const place_mobile = data.place_mobile;
            const fee_id = data.fee_id;
            const fee_type_description = data.fee_type_description;
            const fee_type_unit = data.fee_type_unit;
            const place_owner = data.place_owner
            const user_id = data.user_id;
            const invoice_id = data.invoice_id;
            const zone_name = data.zone_name
            const block_id = data.block_id
            const fee_type_price = formatter.format(data.fee_type_price);
            const fee_count = data.fee_count;
            const fee_price = formatter.format(data.fee_price);
            const service_price = formatter.format(data.service_price);
            const sum = formatter.format(data.fee_price + data.service_price);
            const total = sum;
            const barcode_bill = data.invoice_id;
            const barcode_cus_place = data.customer_id + ' ' + data.place_id;
            const create_datetime = +moment(data.create_datetime).format("YYYY") <= new Date().getFullYear() ? moment(data.create_datetime).add(543, 'year').format("DD/MM/YYYY HH:mm:ss") : moment(data.create_datetime).format("DD/MM/YYYY HH:mm:ss")
            const price = formatter.format(data.total_price);
            const total_price = data.total_price;
            const barcode = customer_id + ' ' + place_id;
            const total_price_bath = bath(price);
            this.total.push(price)
            let fee_description;
            let xy = 0;
            xy = parseInt(moment(data.due_date).format('YYYY'));

            if (xy < 2500) {
              xy += 543;
            }

            const due_datetime = moment(data.due_date).format("DD/MM/") + xy;
            switch (moment(data.due_date).format("MM")) {
              case '01':
                fee_description = data.fee_description + ' (มกราคม)';
                break;
              case '02':
                fee_description = data.fee_description + ' (กุมภาพันธ์)';
                break;
              case '03':
                fee_description = data.fee_description + ' (มีนาคม)';
                break;
              case '04':
                fee_description = data.fee_description + ' (เมษายน)';
                break;
              case '05':
                fee_description = data.fee_description + ' (พฤษภาคม)';
                break;
              case '06':
                fee_description = data.fee_description + ' (มิถุนายน)';
                break;
              case '07':
                fee_description = data.fee_description + ' (กรกฏาคม)';
                break;
              case '08':
                fee_description = data.fee_description + ' (สิงหาคม)';
                break;
              case '09':
                fee_description = data.fee_description + ' (กันยายน)';
                break;
              case '10':
                fee_description = data.fee_description + ' (ตุลาคม)';
                break;
              case '11':
                fee_description = data.fee_description + ' (พฤศจิกายน)';
                break;
              case '12':
                fee_description = data.fee_description + ' (ธันวาคม)';
                break;
            }

            return {
              user_id,
              invoice_id,
              fee_description,
              fee_type_price,
              fee_count,
              fee_price,
              service_price,
              total,
              due_datetime,
              mobile,
              place_mobile,
              zone_name,
              datenew,
              customer_id,
              block_id,
              customer_name,
              place_id,
              place_address,
              tambon,
              amphur,
              province,
              postcode,
              place_description,
              fee_id,
              fee_type_description,
              fee_type_unit,
              place_owner,
              barcode_bill,
              barcode_cus_place,
              create_datetime,
              price,
              total_price,
              barcode,
              total_price_bath,
            }
          })
          console.log(this.detail)

          this.total_baht = formatter.format(this.total.reduce((accumulator, currentValue) => accumulator + currentValue, 0))


          var xy = 0;
          xy = parseInt(moment().format('YYYY'));

          if (xy < 2500) {
            xy = xy + 543;
          }

          this.now = moment().format("DD/MM/") + xy;

          xy = 0;
          xy = parseInt(moment(result.data[0].create_datetime).format('YYYY'));

          if (xy < 2500) {
            xy = xy + 543;
          }

          console.log(this.total_price_bath)
          this.service.postData({ user_id: result.data[0].user_id }, "user-location/get-user-detail").then((result2: any) => {
            if (!result2.code) {
              if (result2.data.length > 0) {
                this.user = result2.data[0].user_name;
                setTimeout(() => {
                  window.print();
                }, 1000);
              } else {
                this.user = result2.data[0].user_id;
                setTimeout(() => {
                  window.print();
                }, 1000);
              }
            }
            else {
              Swal.fire({
                title: result.message,
                text: '',
                type: 'error',
                showCancelButton: false,
                showConfirmButton: false,
                timer: 500
              });
            }

          })

        }

      }
      else {
        Swal.fire({
          title: result.message,
          text: '',
          type: 'error',
          showCancelButton: false,
          showConfirmButton: false,
          timer: 2000
        })
      }

    })
  }


}
